const SplitPaymentTransactions = () => {
	return <div>SplitPaymentTransactions</div>;
};

export default SplitPaymentTransactions;
